export enum TripStatusEnum {
  Accepted = 3,
  Scheduled = 15,
  Hold = 14,
  Active = 2,
  OnMyWay = 17,
  Arrived = 16,
  PickUp = 5,
  DropOff = 10,
  Open = 1,
  NoShow = 6,
  Cancelled = 7,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/trips-status.enum.ts